import { Injectable, Injector } from '@angular/core';
import { BaseResourceService } from 'eddydata-lib';
import { DocumentoSubcontratacao } from 'projects/eddydata-lib/src/lib/entidade/contabil/documento-subcontratacao.model';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DocumentoSubcontratacaoService extends BaseResourceService<DocumentoSubcontratacao> {

  constructor(
    protected injector: Injector
  ) {
    super('documento-subcontratacao', injector);
  }

  desvincularDocumentoSubcontratacaoLiquidacao(documentoFiscalId: number): Observable<any> {

    return this.http.delete(`${this.login.cidade.id}/${this.api}/desvincular-documento-subcontratacao-liquidacao/${documentoFiscalId}`, this.httpOptions()).pipe(
      map(res => res),
      catchError(err => this.handleError(err))
    );
  }

  desvincularLiquidacao(liquidacaoId: number, tipo: String): Observable<any> {

    return this.http.put(`${this.login.cidade.id}/${this.api}/desvincular-liquidacao/${liquidacaoId}/${tipo}`, {}, this.httpOptions()).pipe(
      map(res => res),
      catchError(err => this.handleError(err))
    );
  }
}